import { computed, unref } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobilePlayer2() {
    const display = useDisplay();

    return computed(() => {
      return unref(display.width) < 990
    });
}